import { Card, Form, Input, Row, Col, Space, Button, message } from 'antd'
import CheckProductList from './CheckProductList'
import service from '../../../@services'
import {
  PlusOutlined,
  CloseOutlined,
  DownloadOutlined
} from '@ant-design/icons'
import useUpLoadGetProductList from '../../../@hooks/useUpLoadGetProductList'
import useFullListGetPageData from '../../../@hooks/useFullListGetPageData'
import ProductSearchModal from '../../Product/components/ProductSearchModal'
import useGetCheckBillAmountText from '../hooks/useGetCheckBillAmountText'
import * as Utils from '../../../@utils'
import { plusMumber, getNumProduct } from '../../../@utils'

import { useState, useMemo, useEffect } from 'react'
import '../../../style/card.less'
const importProductUrl = 'inventory/check-sheet/import-product'
const rowKey = 'barcode'
const useUploadFileGetProductInfos = ({ recordUpdate, storeCode }) => {
  const [finalList, setList] = useState([])
  const { list, uploadBtn } = useUpLoadGetProductList({
    actionUrl: importProductUrl,
    requestData: { storeCode }
  })
  const handleSave = row => {
    const newData = [...finalList]
    const index = newData.findIndex(item => row[rowKey] === item[rowKey])
    let item = newData[index]
    item = recordUpdate(row)
    newData.splice(index, 1, item)
    setList(newData)
  }
  useEffect(() => {
    setList(list)
    // getProductInfoByBarcode(list.map(item => item.barcode)).then(data => {
    //   data && data.length > 0 && setList(data)
    // }, storeCode)
    return () => {}
  }, [list])
  return {
    setList,
    list: finalList,
    handleSave,
    uploadBtn
  }
}

export default function AddCheckBill({
  hide = () => {},
  checkNo = '',
  getList = () => {},
  storeCode
}) {
  const [loading, setLoading] = useState(false)
  const { list, setList, uploadBtn, handleSave } = useUploadFileGetProductInfos(
    {
      storeCode,
      recordUpdate: record => {
        const originRecord = list.filter(
          item => item.barcode == record.barcode
        )[0]
        let updateRight = !isNaN(parseInt(record.checkStock))
        if (!updateRight) {
          record.checkStock = originRecord.checkStock
        }

        return {
          ...record,
          checkDiffer: (record.productStock || 0) - (record.checkStock || 0)
        }
      }
    }
  )
  const [showAddProductList, setShowAddProductList] = useState(false)
  const listBarcodes = useMemo(
    () => (list && list.map(item => item.barcode)) || [],
    [list]
  )
  const { getDefaultProductList } = useGetDefaultProductList(checkNo, setList)
  const displayData = useGetDisplayDataByList(list)
  const { amountInfoText } = useGetCheckBillAmountText(displayData)
  const [page, setPage] = useState({
    pageIndex: 1,
    pageSize: 10
  })
  const { pageData } = useFullListGetPageData({ list, page })
  const [form] = Form.useForm()
  const operateColumns = [
    {
      title: '操作',
      dataIndex: 'barcode',
      render: (text, record, index) => (
        <Button
          size='small'
          onClick={() =>
            setList(list.filter(item => item.barcode != record.barcode))
          }>
          删除
        </Button>
      )
    }
  ]
  const getDraftBill = async () => {
    setLoading(true)
    try {
      const res = await service.inventory.getCheckSheetDeail(checkNo)
      if (res) {
        form.setFieldsValue({
          sheetName: res.sheetName,
          checkUserName: res.checkUserName,
          note: res.note
        })
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const saveBillAsDraft = async () => {
    setLoading(true)
    try {
      await form.validateFields()
      await service.inventory.createCheckSheet({
        ...form.getFieldsValue(),
        storeCode,
        productList: list
      })
      hide()
      getList()
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const completeBill = async () => {
    await form.validateFields()
    await service.inventory.completeCheckSheet({
      ...form.getFieldsValue(),
      storeCode,
      productList: list
    })
    hide()
    getList()
  }
  const downLoadFile = async () => {
    let res = await service.common.getFileTemplate({
      fileType: 'checkSheetImportProduct'
    })
    let fileName = `盘点单商品${Utils.parseTime(Date.parse(new Date()))}.xlsx`
    Utils.download(res, fileName)
  }
  const confirmProductList = async _list => {
    let barcodes = _list
      .filter(item => listBarcodes.indexOf(item.barcode) < 0)
      .map(item => item.barcode)
    if (_list && barcodes.length) {
      let productInfoList = await getProductInfoByBarcode(barcodes, storeCode)
      setList([...productInfoList, ...list])
    }
    setShowAddProductList(false)
  }
  const footer = (
    <Space style={{ textAlign: 'right' }}>
      <Button type='primary' onClick={saveBillAsDraft} loading={loading}>
        存为草稿
      </Button>
      <Button type='primary' onClick={completeBill} loading={loading}>
        完成盘点
      </Button>
      <Button onClick={hide}>取消</Button>
    </Space>
  )
  useEffect(() => {
    if (checkNo) {
      getDefaultProductList()
      getDraftBill()
    }
    return () => {}
  }, [checkNo])
  return (
    <Card
      title='新增手工盘点'
      className='customer-card'
      actions={[footer]}
      extra={<CloseOutlined onClick={hide} />}>
      <Form form={form} layout='inline' initialValues={{ checkNo }}>
        <Row>
          <Col span={7}>
            <Form.Item name='checkNo' label='单据编号'>
              <Input disabled placeholder='请输入' />
            </Form.Item>
          </Col>
          <Col span={7} offset={1}>
            <Form.Item
              name='sheetName'
              label='盘点名称'
              rules={[{ required: true, message: '请输入盘点名称' }]}>
              <Input placeholder='请输入' />
            </Form.Item>
          </Col>
          <Col span={7} offset={1}>
            <Form.Item
              name='checkUserName'
              rules={[{ required: true, message: '请输入经手人' }]}
              label='经手人'>
              <Input placeholder='请输入' />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <div style={{ textAlign: 'left', margin: '20px 0' }}>
        <Space>
          <Button
            type='primary'
            icon={<PlusOutlined />}
            onClick={() => setShowAddProductList(true)}>
            选择商品
          </Button>
          {uploadBtn}
          <Button
            type='primary'
            icon={<DownloadOutlined />}
            onClick={downLoadFile}>
            下载模板
          </Button>
        </Space>
      </div>
      <CheckProductList
        page
        edit
        editDataIndex='checkStock'
        handleSave={handleSave}
        getList={setPage}
        operateColums={operateColumns}
        pageData={pageData}
      />
      <ProductSearchModal
        storeCode={storeCode}
        visible={showAddProductList}
        otherTips='备注：若商品未进行采购入库，盘点时商品将添加不成功。'
        close={() => setShowAddProductList(false)}
        confirmListHaveInfo={confirmProductList}
      />
      {amountInfoText}
      <Form form={form}>
        <Form.Item
          name='note'
          label='备注'
          rules={[
            { max: 100, message: '备注不超过100个字符', type: 'string' }
          ]}>
          <Input.TextArea placeholder='请输入备注' />
        </Form.Item>
      </Form>
    </Card>
  )
}

const useGetDisplayDataByList = (list = []) => {
  const { checkProductTypeNum, checkAllNum, checkDifferentAmount } =
    useMemo(() => {
      let cataList = [],
        _checkAllNum = 0,
        checkDifferentAmount = 0
      if (list.length > 0) {
        list.map(item => {
          cataList.indexOf(item.categoryName) < 0 &&
            cataList.push(item.categoryName)
          _checkAllNum += (item.checkStock || 0) - 0
          checkDifferentAmount =
            item.checkStock !=null && item.costPrice
              ? plusMumber(
                  checkDifferentAmount,
                  getNumProduct(
                    plusMumber(item.checkStock, 0 - Number(item.productStock)),
                    item.costPrice
                  )
                )
              : 0
        })
      }
      return {
        checkProductTypeNum: list.length,
        checkAllNum: _checkAllNum,
        checkDifferentAmount: checkDifferentAmount
      }
    }, [list])
  return {
    checkProductTypeNum,
    checkAllNum,
    checkDifferentAmount
  }
}

const useGetDefaultProductList = (checkNo, setList) => {
  const getList = async () => {
    const list = await service.inventory.getCheckSheetDeailProductList({
      checkNo,
      pageIndex: 1,
      pageSize: 1000
    })
    list.result && setList(list.result)
  }
  return {
    getDefaultProductList: getList
  }
}

const getProductInfoByBarcode = (barcodes = [], storeCode) =>
  barcodes.length > 0
    ? service.inventory.queryCheckSheetProductList({
        barcodeList: barcodes,
        storeCode
      })
    : Promise.resolve([])
